import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CouponData } from "../coupon";

export const useCouponModalState = () => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("..");
  };

  const [coupon] = useState(() => {
    const data = sessionStorage.getItem("COUPON_DATA");
    if (!data) return { merchants: [] as any, users: [] as any } as CouponData;
    return JSON.parse(data) as CouponData;
  });
  return { handleClose, coupon };
};
